import type { SchemaObject } from 'ajv';
import _ from 'lodash';
import type { Patch, PatchEntry } from './types';

function isPropertyType(schema: SchemaObject) {
  return (
    _.has(schema, 'properties') &&
    _.has(schema.properties, 'value') &&
    _.has(schema.properties, 'defaultValue') &&
    _.has(schema.properties, 'isRequired')
  );
}

const patchPropertyTypeSchema: Patch = (schema) => {
  if (!isPropertyType(schema)) return;

  if (schema.properties.isRequired) {
    schema.if = { properties: { isRequired: { const: true } } };
    schema.then = { required: [...(schema.required || []), 'value'] };
  }

  if (schema.properties.min) schema.properties.value.minimum = { $data: '1/min' };
  if (schema.properties.max) schema.properties.value.maximum = { $data: '1/max' };

  // make always nullable
  schema.properties.value = {
    ...schema.properties.value,
    nullable: true,
  };
};

export const propertyTypePatchEntry: PatchEntry = {
  condition: isPropertyType,
  patch: patchPropertyTypeSchema,
};
